import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PlayerColumn = styled.div`
    ${BaseStyle.Mixins.gaps.medium};
    display: flex;
    align-items: center;

    .headshot-container {
        margin: auto 0;

        ${BaseStyle.Mixins.screenSizes.small} {
            display: none;
        }
    }
`;

export const StyledPlayerLink = styled.a`
    ${BaseStyle.Mixins.fontStyles.table.bold};
`;
